import '../index.css';
export { default } from './PageRoutes';
export * from './PageRoutes';
export { default as BernoulliHome } from './BernoulliHome/BernoulliHome';
export {
  clearEmbeddedHostContext,
  setEmbeddedAuthToken,
  setEmbeddedProductLineName,
  setEmbeddedTenantId,
} from '@/services/agentBaseUrl';
